import { NotifyHelper } from "../../../helpers/toast";
import { objCaAnTruongDefine } from "../../action-types/thuc-don/IFoCaAnTruongActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const foCaAnTruongActions = {
    ...generateActions(objCaAnTruongDefine, "CA_AN_TRUONG"),
    ...generateActionForKey(objCaAnTruongDefine, "CA_AN_TRUONG",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objCaAnTruongDefine, "CA_AN_TRUONG",
        "LOAD_COSO_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objCaAnTruongDefine, "CA_AN_TRUONG",
        "LOAD_COSO_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objCaAnTruongDefine, "CA_AN_TRUONG",
        "LOAD_CAAN_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objCaAnTruongDefine, "CA_AN_TRUONG",
        "LOAD_CAAN_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objCaAnTruongDefine, "CA_AN_TRUONG",
        "SAVE_SUCCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objCaAnTruongDefine, "CA_AN_TRUONG",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objCaAnTruongDefine, "CA_AN_TRUONG",
        "DELETE_SUCCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objCaAnTruongDefine, "CA_AN_TRUONG",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
